import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateDoctorRequest,
  DoctorSearchParams,
  ResponseCompanyDoctorInvite
} from '../Types/Requests/DoctorRequests'
export type MobileStoresUrls = {
  androidUrl: string
  iosUrl: string
}
export default class DoctorService extends Service {
  prefix: string
  constructor() {
    super()
    this.prefix = '/doctors'
  }

  async create(payload: CreateDoctorRequest): Promise<MobileStoresUrls> {
    try {
      const { data } = await request.post<MobileStoresUrls>(this.getCompletePath(''), payload)
      return data
    } catch (e) {
      throw this.handleError(
        e,
        'Não foi possível concluir o seu cadastro. Revise os dados e tente novamente.'
      )
    }
  }

  async sendResponseToCompanyDoctorInvite(
    payload: ResponseCompanyDoctorInvite
  ): Promise<MobileStoresUrls> {
    try {
      const { data } = await request.post<MobileStoresUrls>(
        this.getCompletePath('/invite-accept'),
        payload
      )
      return data
    } catch (e) {
      throw this.handleError(
        e,
        payload.accept
          ? 'Não foi possível aceitar o convite. Tente novamente.'
          : 'Não foi possível recusar o convite. Tente novamente.'
      )
    }
  }

  async searchDoctors(searchTerm: string): Promise<DoctorSearchParams[]> {
    if (!searchTerm) {
      console.warn('O termo de busca está vazio. Retornando array vazio.')
      return []
    }

    try {
      const url = this.getCompletePath('/search')

      const { data } = await request.get<DoctorSearchParams[]>(url, { search: searchTerm })

      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível buscar os médicos. Tente novamente.')
    }
  }
}
